/**
 *  @class
 *  @function ModalDialog
 *  @version 1.0.1
 */
if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      this.age_verification = this.classList.contains('age-verification-modal');
      this.id = this.getAttribute('id');
      this.delay = parseInt(this.dataset.delay, 10) * 1000;
      this.expiration_days = parseInt(this.dataset.expirationDays, 10);
      this.popup = this.dataset.popup;
      this.section_id = this.dataset.sectionId;
      this.disabled = this.getAttribute('disabled') != undefined;
      this.button = this.querySelector('[id^="ModalClose-"]');

      this.button.addEventListener('click', this.hide.bind(this));

      if (!this.disabled) {
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') {
            this.hide();
            this.setCookie();
          }
        });
        this.addEventListener('click', (event) => {
          if (event.target.nodeName === 'MODAL-DIALOG') {
            this.hide();
            this.setCookie();
          }
        });

        // Prevent popup from reappearing after form submission
        this.querySelectorAll('form').forEach((form) => {
          form.addEventListener('submit', () => {
            this.setCookie();
          });
        });
      }
      if (this.delay && this.delay > 0) {
        if (!this.getCookie()) {
          setTimeout(() => {
            this.show();
            this.button.addEventListener('click', this.setCookie.bind(this));
          }, this.delay);
        }
      } else if (parseInt(this.dataset.delay, 10) === 0) {
        if (!this.getCookie()) {
          this.show();
          this.button.addEventListener('click', this.setCookie.bind(this));
        }
      }
      if (this.age_verification) {
        if (!this.getCookie()) {
          this.show();
        }
        this.button.addEventListener('click', this.setCookie.bind(this));
      }
      if (Shopify.designMode) {
        this.moved = true;
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.section_id) {
            this.show();
          }
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.section_id) {
            this.hide();
          }
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');

      setTimeout(() => {
        this.querySelector('[role="dialog"]').focus();
      }, 100);
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());

      if (this.popup) {

      }
    }

    getCookie() {
      const storedValue = window.localStorage.getItem(this.id);

      if (!storedValue) {
        return null;
      }

      if (!this.expiration_days || this.expiration_days <= 0) {
        return storedValue;
      }

      try {
        const parsedValue = JSON.parse(storedValue);
        const rawDate = parsedValue && parsedValue.date ? parsedValue.date : storedValue;
        const savedDate = new Date(rawDate);

        if (Number.isNaN(savedDate.getTime())) {
          window.localStorage.removeItem(this.id);
          return null;
        }

        const elapsedMs = Date.now() - savedDate.getTime();
        const maxAgeMs = this.expiration_days * 24 * 60 * 60 * 1000;

        if (elapsedMs > maxAgeMs) {
          window.localStorage.removeItem(this.id);
          return null;
        }

        return storedValue;
      } catch (error) {
        window.localStorage.removeItem(this.id);
        return null;
      }
    }
    setCookie() {
      window.localStorage.setItem(this.id, JSON.stringify({
        date: new Date().toISOString()
      }));
    }
  }
  customElements.define('modal-dialog', ModalDialog);
}
if (!customElements.get('modal-opener')) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');

      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
}